module.exports = __webpack_public_path__ + "img/restaurant--icon--gray.83c67f5e.svg";